import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useRatingContext } from './RatingContext';
import { HiStar } from 'react-icons/hi';
const sizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-7 h-7',
    lg: 'w-10 h-10',
};
export const RatingStar = ({ filled = true, starIcon: StarIcon = HiStar }) => {
    const { size = 'sm' } = useRatingContext();
    return (_jsx(StarIcon, { className: classNames(sizeClasses[size], {
            'text-yellow-400': filled,
            'text-gray-300 dark:text-gray-500': !filled,
        }) }));
};
